<template>
    <div class="content">
        <jabra-breadcrumbs></jabra-breadcrumbs>
        <div class="header">{{l10nTalmud}}</div>
        <div class="sub-header">{{l10nTheTalmudIsTranslatedIntoSpanish}}</div>
        <jabra-progress-linear v-if="products.state === LOADING_STARTED"></jabra-progress-linear>
        <div class="divider" v-else></div>
        <div class="products-section">
            <div v-if="products.data">
                <div v-for="(product, index) in products.data" class="product-container">
                    <div class="product">
                        <div class="details-section" v-on:click="navigateToTalmudItem(product)">
                            <div class="product-image-container">
                                <img src="../assets/images/talmud_thumb.png" alt="talmud thumbnail">
                            </div>
                            <div class="product-info">
                                <div class="product-name">
                                    <span>{{product.name}}</span>
                                </div>
                                <div class="product-divider"></div>
                                <div class="product-price-range">
                                    <span>{{minPrice(product)}}$</span>
                                    <span>-</span>
                                    <span>{{maxPrice(product)}}$</span>
                                </div>
                            </div>
                        </div>
                        <div class="actions-section">
                            <div class="variant-dropdown">
                                <jabra-dropdown :data="variantLabels(product)"
                                                v-on:jbr-select="upsertData(variants, product.id, $event)"></jabra-dropdown>
                            </div>
                            <div class="spacer"></div>
                            <div class="quantity-selector">
                                <jabra-stepper
                                        v-on:sfr-stepper-change="upsertData(quantities, product.id, $event)"></jabra-stepper>
                            </div>
                            <div class="further-details-cart">
                                <div class="action-further-details">
                                    <span v-on:click="toggleExpandProduct(index)">{{l10nForFurtherDetails}}</span>
                                </div>
                                <div class="action-add-to-cart">
                                    <jabra-btn dark v-on:jbr-click="addToCart(product)"
                                               :disabled="variants[product.id] === null">
                                        <span class="add-to-cart-text">{{l10nAddToCart}}</span>
                                    </jabra-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition name="ease">
                        <div v-if="isProductExpanded(index)" class="product-expanded">
                            <div class="further-details">
                                <div v-for="variant in product.variant">
                                    <div class="size-description">
                                        <div class="size-name">
                                            <span>{{variant.short_name}}</span>
                                        </div>
                                        <div class="size-details">
                                            <div class="size-price">
                                                <span>{{variant.price}}$</span>
                                            </div>
                                            <div class="jabra-long-text">
                                                <div v-html="variant.details"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        LOAD_TALMUD_PRODUCTS,
        LOADING_STARTED,
        ADD_TO_CART,
        CATEGORY_TALMUD,
    } from '../services/constants'
    import helpers from '../services/helpers'

    export default {
        name: 'store-talmud-component',
        data: function () {
            return {
                LOADING_STARTED: LOADING_STARTED,
                expanded: [],
                quantities: {},
                variants: {},
            }
        },
        computed: {
            products() {
                return this.$store.state.commerceModule.talmudProducts
            },
            language() {
                return this.$store.state.languageModule.currentLanguage
            },
            masechetNamePrefix() {
                return this.$store.state.commerceModule.masechetNamePrefix
            },
            l10nTalmud() {
                return this.l10nGetter('talmud')
            },
            l10nTheTalmudIsTranslatedIntoSpanish() {
                return this.l10nGetter('the_talmud_is_translated_into_spanish')
            },
            l10nAddToCart() {
                return this.l10nGetter('add_to_cart')
            },
            l10nForFurtherDetails() {
                return this.l10nGetter('for_further_details')
            },
        },
        watch: {
            language(newVal) {
                this.init()
            }
        },
        methods: {
            isProductExpanded(index) {
                return this.expanded.indexOf(index) > -1
            },
            toggleExpandProduct(index) {
                const i = this.expanded.indexOf(index)
                if (i === -1) {
                    this.expanded.push(index)
                } else {
                    this.expanded.splice(i, 1)
                }
            },
            upsertData(store, key, value) {
                this.$set(store, key, value)
            },

            minPrice(product) {
                return helpers.minPrice(product)
            },
            maxPrice(product) {
                return helpers.maxPrice(product)
            },
            variantLabels(product) {
                return helpers.variantLabels(product)
            },
            addToCart(product) {
                const productForCart = {
                    productId: product.id,
                    item: CATEGORY_TALMUD,
                    name: `${this.masechetNamePrefix} ${product.name}`,
                    variant: this.variants[product.id],
                    unitPrice: product.variant.find(eachVariant => {
                        return eachVariant.short_name === this.variants[product.id]
                    }).price,
                    quantity: this.quantities[product.id],
                }
                this.$store.dispatch(ADD_TO_CART, productForCart)
            },
            navigateToTalmudItem(product) {
                this.$router.push({name: 'storeTalmudItem', params: {id: `${product.id}`}})
            },
            init() {
                if (this.language) {
                    this.$store.dispatch(LOAD_TALMUD_PRODUCTS)
                }
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        },
        created() {
            this.init()
        },
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        background: $background-color-grey;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 70px 245px 130px;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .sub-header {
        @include font-abraham(36px, $font-color-blue, 300);
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .products-section {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .product-container {
        margin: 0 0 27px 0;
        border-left: $accent-1 solid 1px;
        box-shadow: 0 1px 13px 0 $grey-3;
        background: white;
    }

    .product {
        display: flex;
        justify-content: space-between;
        padding: 29px 32px 22px 26px;
    }

    .details-section {
        display: flex;
        cursor: pointer;
    }

    .product-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 30px 20px;
    }

    .product-name {
        @include font-abraham(30px, $font-color-blue, 400);
    }

    .product-price-range {
        display: flex;
        justify-content: center;
        min-width: 218px;
        background: $accent-2;
        @include font-abraham(28px, $font-color-blue, 400);
    }

    .actions-section {
        display: flex;
    }

    .variant-dropdown, .quantity-selector {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    .spacer {
        width: 10px;
    }

    .product-divider {
        width: 58px;
        height: 8px;
        background: $accent-1;
    }

    .further-details-cart {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 0 0 0 32px;
    }

    .action-further-details {
        @include font-abraham(20px, $accent-1, 400);
        margin: 0 0 25px 0;
        span {
            cursor: pointer;
        }
    }

    .add-to-cart-text {
        font-size: 20px;
        line-height: 50px;
        padding: 0 15px;
    }

    .product-expanded {
        display: flex;
        justify-content: flex-end;
        background: $accent-2-alpha;
        padding: 20px 40px;

        $transition-duration: 0.1s;
        &.ease-enter-active, &.ease-leave-active {
            opacity: 1;
            max-height: 184px;
            transition: max-height $transition-duration, padding $transition-duration, opacity $transition-duration;
        }

        &.ease-enter, &.ease-leave-to {
            opacity: 0;
            padding: 0 40px;
            max-height: 0;
        }
    }

    .further-details {
        display: flex;
    }

    .size-description {
        display: flex;
        @include font-abraham(18px, $font-color-blue, 500);
    }

    .size-name {
        @include font-abraham(18px, $font-color-blue, 500);
        span {
            line-height: 40px;
        }
    }

    .size-details {
        @include font-abraham(20px, $font-color-lighter-blue, 400);
        padding: 0 16px;
    }

    .size-price {
        span {
            line-height: 40px;
            padding: 0 27px;
            background: $accent-2-alpha;
        }
    }

    .size-detail {
        @include font-abraham(18px, $font-color-blue, 400);
        padding: 3px;
    }
</style>
